import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress } from "@material-ui/core";
import { useStyles } from './styles';
import hardshipImg from '../../assets/hardship.png';
import Federal from '../../assets/FinancialHardship/Federal.svg';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getContent, getFinancialHardShipTiles, getSpocDetails } from '../../actions';
import { scrollTop, renderDefaultMsg, getAppSource, getUserType, liquidationBtnStatus  } from '../../helpers';
import { DisasterAlert } from '../../components';
import Cookies from 'js-cookie';
import CustomBreadcrum from '../Breadcrum';
import { LmaNotAllowed } from './LmaNotAllowed';
import { SpocDetails } from './SpocDetails';

export const FinancialHardship = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useSelector(state => state.theme);
  const { customerCareNumber } = theme;
  const [topContent, setTopContent] = useState(null);
  const [middelContent, setMiddelContent] = useState(null);
  const [bottomContent, setBottomContent] = useState(null);
  const [financialHardShipTiles, setFinancialHardShipTiles] = useState([]);
  const [confirmAlert, setIsAgencyLoan] = React.useState(false);
  const [errMessage, setErrorMessage] = useState();
  const [spocDetail, setSpocDetails] = useState();
  const [lmaNotAllowedStatus, setLmaNotAllowedStatus] = useState(false);
  const [spocStatus, setSpocStatus] = useState(false);

  const getContentData = async () => {
    const res = await dispatch(getContent('PC020'));
    if (res) {
      res.map(content => {
        switch (content.contentKey.toUpperCase()) {
          case 'TOP1':
            setTopContent(content);
            return;
          case 'MIDDEL':
            setMiddelContent(content);
            return;
          case 'BOTTOM':
            setBottomContent(content);
            return;
          default:
            break;
        }
      })
      scrollTop();
    }
  }

  const getFinancialHardShipData = async () => {
    const res = await getFinancialHardShipTiles();
    if (res && res.lstResponseStatus[0].statusCode === '0') {
      const tiles = res.financialHardshipTiles.map(tile => {
        if (tile.tilesName.toUpperCase() === 'DontWaitWeCanHelp'.toUpperCase()) {
          tile.tilesBody = tile.tilesBody.replace("[CCNo]", customerCareNumber);
        }
        return tile;
      })
      if (Cookies.get("displayNaturalDisasterLink") == 'true') {
        setFinancialHardShipTiles(tiles)
      } else {
        const a = tiles.findIndex((tile) => tile.tilesName == "DisasterAssistance" )
        if (a !== -1) {
          const b = tiles.splice(a,1)
          setFinancialHardShipTiles(tiles)
        }
      }
     
      scrollTop();
    } else {
      scrollTop();
    }
  }

  useEffect(() => {
    getContentData();
    getFinancialHardShipData();
    if (props.accountNumber !== "") {
      getSpocDetail()
    }
  }, [props])

  const getSpocDetail = async () => {
    const data = {
      "accountNumber": props.accountNumber,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await getSpocDetails(data);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      setSpocDetails(res?.responseData?.responseData)
      setErrorMessage() 
    } else {
      setErrorMessage(renderDefaultMsg('400'))
    }
  }

  const handleClose = () => {
    setIsAgencyLoan(false);
  }

  const routePage = (url) => {    
    if (url.tilesName == "DisasterAssistance") {
      if (Cookies.get("isAgencyLoan") == 'false') {
        setIsAgencyLoan(true)
      } else {
         history.push(`/DisasterAssistance`);
      }
    }
  }
 
  if (financialHardShipTiles.length === 0) {
    return (
      <Box className={classes.loaderContainer}>
        <CircularProgress />
      </Box>
    )
  }

  const routeToLma = () => {
    if (spocDetail.lmaStatus.toLowerCase() == "blank") {
      history.push(`/Lma`);
    } else if (spocDetail.lmaStatus.toLowerCase() == "spoc") {
      setSpocStatus(true)
    } else {
      setLmaNotAllowedStatus(true)
    }
  }

  const closeLmaNotAllowPopup = () => {
    setLmaNotAllowedStatus(false)
  }

  const closeSpocDetailsPopup = () => {
    setSpocStatus(false)
  }

  const getButtonStatus = () => {
    if ((spocDetail?.lmaStatus.toLowerCase() == "blank") || (spocDetail?.lmaStatus.toLowerCase() == "spoc") || (spocDetail?.lmaStatus.toLowerCase() == 'lma not allowed')) {
      return <Button className={classes.btn} variant="contained" color='primary' onClick={routeToLma} disabled={(spocDetail?.spocInformation !== null) ? false : liquidationBtnStatus()}>file hardship</Button>
    } else if (spocDetail?.lmaStatus.toLowerCase() == "in progress") {
      return <Button component={Link} to='/LmaDetails' className={classes.btn} variant="contained" color='primary' disabled={liquidationBtnStatus()}>file hardship</Button>
    } else {
      return <Button component={Link} to='/LmaStatus' className={classes.btn} variant="contained" color='primary' disabled={liquidationBtnStatus()}>View Application Status</Button>
    }
  }

  return (
    <Box className={classes.pageBg}>
      <Box className={classes.root}>
       
        <CustomBreadcrum backPage="Payments" backPageLink="/PaymentOption" activePage="Financial Hardship" />

        <h1 className={classes.title}>Mortgage Assistance - Know Your Options</h1>
        <Box className={classes.container}>
          <Box className={classes.havingDifficulty}>
            <Box className={classes.havingDifficultyContent}>
              {topContent && topContent.contentHeader && <h3 className={classes.subTitle} dangerouslySetInnerHTML={{ __html: topContent.contentHeader }}></h3>}
              {topContent && topContent.contentValue && <p className={classes.text} dangerouslySetInnerHTML={{ __html: topContent.contentValue }} />}
              {spocDetail && <Box className={classes.buttonBox}>
                 {getButtonStatus()}
                {/* {((spocDetail?.lmaStatus.toLowerCase() == "blank") || (spocDetail?.lmaStatus.toLowerCase() == "spoc") || (spocDetail?.lmaStatus.toLowerCase() == 'lma not allowed')) && <Button className={classes.btn} variant="contained" color='primary' onClick={routeToLma} disabled={(spocDetail.spocInformation !== null) ? false : liquidationBtnStatus()}>file hardship</Button>}

                {((spocDetail?.lmaStatus.toLowerCase() == "submitted") || (spocDetail?.lmaStatus.toLowerCase() == "complete")) && <Button component={Link} to='/LmaStatus' className={classes.btn} variant="contained" color='primary' disabled={liquidationBtnStatus()}>View Application Status</Button>}

                {(spocDetail?.lmaStatus.toLowerCase() == "in progress") && <Button component={Link} to='/LmaDetails' className={classes.btn} variant="contained" color='primary' disabled={liquidationBtnStatus()}>file hardship</Button>} */}
                
                {/* <Button component={Link} to='/LmaStatus' className={classes.btn} variant="contained" color='primary' disabled={liquidationBtnStatus()}>View Application Status</Button> */}
             </Box> }
            </Box>
            <Box className={classes.havingDifficultyImgContainer}>
              <img className={classes.havingDifficultyImg} src={hardshipImg} alt='pic' />
            </Box>
          </Box>
        </Box>
        <Box className={classes.container}>
          <Box>
            {middelContent && middelContent.contentHeader && <h3 className={classes.subTitle} dangerouslySetInnerHTML={{ __html: middelContent.contentHeader }} />}
            {middelContent && middelContent.contentValue && <p className={classes.text} dangerouslySetInnerHTML={{ __html: middelContent.contentValue }} />}            
          </Box>
          <Box className={classes.cardContainer}>
            {financialHardShipTiles.map(tile => 
              {
              return (
              
                <Box className={classes.card} key={tile.id}>
                  <img className={classes.cardIcon} src={tile.tilesImageUrl} alt='icon' />
                  <Box className={classes.cardContent}>
                    <h3 className={classes.cardTitle}>{tile.tilesTitle}</h3>
                    <p className={classes.cardText}>{tile.tilesBody}</p>
                    <Box className={classes.btnContainer}>
                    
                      { ((tile.tilesName == 'DisasterAssistance') && (Cookies.get("isAgencyLoan") == 'false')) ? 
                       <span className={classes.linkBtn} onClick={() => routePage(tile)}
                       >  {tile.buttonText}
                       </span> :
                       <Link className={classes.linkBtn} to={{
                        pathname: `/${tile.buttonURL}`,
                        state: {
                          tilesName: tile.tilesName
                        }
                      }}>
                        {tile.buttonText}
                      </Link>
                      }
                        
                    </Box>
                  </Box>
                </Box>
              ) 
            })}
          </Box>

          <Box>
            <Box className={classes.accFinancialImgContainer}>
              <img className={classes.accFinancialImg} src={Federal} alt='pic' />
            </Box>
            <Box>
              {bottomContent && bottomContent.contentHeader && <h3 className={classes.subTitle} dangerouslySetInnerHTML={{ __html: bottomContent.contentHeader }} />}
              {bottomContent && bottomContent.contentValue && <p className={classes.text} dangerouslySetInnerHTML={{ __html: bottomContent.contentValue }} />}
            </Box>
          </Box>
        </Box>
      </Box>
      {
        confirmAlert && <DisasterAlert
          open={confirmAlert}
          handleClose={handleClose}
        />
      }
      { lmaNotAllowedStatus &&
          <LmaNotAllowed 
            open={lmaNotAllowedStatus}
            handleCancelIcon={closeLmaNotAllowPopup}
          />
      }
      { spocStatus &&
        <SpocDetails 
          open={spocStatus}
          data={spocDetail}
          handleClose={closeSpocDetailsPopup}
        />
      }
    </Box>
  );
}
